import Image from 'next/image';
import styled, { css } from 'styled-components';

import { device } from '@styles/mediaQuery';
import { ConnectActionButtons } from '@components/atoms';
import useDevice from '@hooks/useDevice';
import { ForwardedRef, forwardRef } from 'react';

function Overlay({}, ref: ForwardedRef<HTMLDivElement>) {
  const { isLaptop, isDesktop } = useDevice();

  return (
    <Wrapper>
      <StyledLogo
        src="/icons/logo_full_white.svg"
        alt="logo"
        width={219}
        height={34}
        loading="lazy"
      />
      <StyledTitle>Quality Services is our law</StyledTitle>

      <DescriptionWrapper>
        <Description>
          Green Line team focuses on being professional, being safe,
        </Description>
        <Description>being courteous and being on time!</Description>
      </DescriptionWrapper>

      {(isLaptop || isDesktop) && (
        <ConnectActionButtons
          width="350px"
          btnWidth="150px"
          margin="30px auto 0"
          ref={ref}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: ${({ theme }) => theme.colors.white};

  ${device.tablet(css`
    padding-top: 50px;

    height: 70%;
    justify-content: center;
    align-items: center;

    padding-left: 0;
  `)};

  ${device.laptopS(css`
    padding-top: 0;
    height: 100%;
  `)};
`;

const StyledLogo = styled(Image)`
  height: 15px;
  width: 100px;
  margin-bottom: 10px;

  ${device.mobileL(css`
    height: 25px;
    width: 150px;
  `)};

  ${device.tablet(css`
    height: 40px;
    width: 200px;
  `)};
`;

const StyledTitle = styled.span`
  font-size: 20px;
  font-weight: 600;

  ${device.mobileL(css`
    font-size: 25px;
    padding-bottom: 10px;
  `)};

  ${device.tablet(css`
    font-size: 50px;
  `)};
`;

const DescriptionWrapper = styled.span`
  display: none;
  flex-direction: column;

  color: ${({ theme }) => theme.colors.athensGray};

  ${device.tablet(css`
    display: flex;
    align-items: center;
  `)};
`;

const Description = styled.span`
  display: flex;
  flex-direction: column;

  line-height: 25px;

  color: ${({ theme }) => theme.colors.athensGray};
`;

export default forwardRef(Overlay);
